var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c('edit-form',{attrs:{"report":_vm.report,"reportType":_vm.reportType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }